import Level from './Level';
import Location from '../seek/Location';
import GameCamera from '../seek/GameCamera';
import Seeker from '../seek/Seeker';
import SeekingAI from '../seek/SeekingAI';
import GameHud from '../ui/GameHud';
import OnboardingController from '../controller/OnboardingController';
import { MODE_HIDE } from '../constants/AppConstants';
import { getGA } from 'analytics/GoogleAnalytics';

export default class LevelHide extends Level {
  /* eslint-disable max-statements */
  create() {
    this.container = this.game.add.group();

    //
    this.location = new Location(this.game, this.locationData, this.levelData.sceneWidth);
    this.container.addChild(this.location);

    // characters to place
    this.setCharsData();

    // add GameCamera
    this.camera = new GameCamera(this.game, this.location);
    this.camera.setPosition(this.levelData.start_point);
    this.navPointId = 0;
    this.calculateNavPoints();
    this.location.camera = this.camera; // add camera for location

    // keyboard control
    this.game.input.keyboard.removeKeyCapture(Phaser.Keyboard.LEFT);
    this.game.input.keyboard.removeKeyCapture(Phaser.Keyboard.RIGHT);

    //
    this.location.disableAllSlots();
    for (let i = 0; i < this.levelData.slots.length; i++) {
      this.location.enableSlot(this.levelData.slots[i]);
    }

    //
    this.gameHud = new GameHud(this.game, this.charsData);
    this.container.addChild(this.gameHud);
    this.gameHud.onScrollLeft.add(this.handleScrollLeft, this);
    this.gameHud.onScrollRight.add(this.handleScrollRight, this);
    this.setArrowsVisibility();
    // this.gameHud.showScrollArrows(this.navPointId > 0, this.navPointId < this.navPoints.length - 1);

    //
    this.toPlace = this.charsData.length;
    this.toFind = this.charsData.length;
    this.found = 0;

    this.screenShots = {};
    this.ratings = {};
    this.foundData = {};

    // events
    this.onHideCharacter = new Phaser.Signal();
    this.onDragCharacter = new Phaser.Signal();

    //
    this.create2();

    // transition
    this.transition = this.game.controller.getTransition();
    this.transition.fadeOut();
  }
  /* eslint-enable */

  create2() {
    // 'your turn to hide' overlay
    this.gameHud.onCloseElinor.addOnce(this.handleCloseElinor1, this);
    this.gameHud.showOverlayElinorTalk(['cs_10a_elinor_002'], 500);
  }

  setCharsData() {
    this.charsData = this.levelData.characters.filter((e) => e.id !== this.seekerId);
  }

  handleResize() {
    this.calculateNavPoints();
    this.setCurrentNavPoint();
  }

  //
  handleCloseElinor1() {
    // onboarding
    this.location.enableControls();

    if (this.levelData.onboarding) {
      this.game.onboarding = new OnboardingController(
        this.game,
        this.levelData.onboarding,
        this.game.cache.getJSON(this.levelData.onboarding + '_config'),
        this
      );
      this.game.onboarding.onEnd.addOnce(this.handleOnboardingEnd, this);
      this.game.onboarding.start();
    }
  }

  //
  handleOnboardingEnd() {
    // init captions once again
    // here is tricky fix for onboarding 4 - dress up
    if (
      this.game.springRollCaptionsPlugin.captions &&
      !this.game.springRollCaptionsPlugin.captions.cs_10a_elinor_002
    ) {
      this.game.springRollCaptionsPlugin.setData(this.cptData);
    }
  }

  // scrolling scene
  handleScrollLeft() {
    this.setCurrentNavPoint();
    this.gameHud.hideScrollArrows();
    if (this.navPointId > 0) {
      this.navPointId--;
    }
    this.camera.destX = this.navPoints[this.navPointId];
    this.gameHud.showScrollArrows(this.navPointId > 0, this.navPointId < this.navPoints.length - 1);
  }

  handleScrollRight() {
    this.setCurrentNavPoint();
    this.gameHud.hideScrollArrows();
    if (this.navPointId < this.navPoints.length - 1) {
      this.navPointId++;
    }
    this.camera.destX = this.navPoints[this.navPointId];
    this.gameHud.showScrollArrows(this.navPointId > 0, this.navPointId < this.navPoints.length - 1);
  }

  //
  removeCurrentDragCharacter() {
    if (this.location.draggable) {
      this.stopDragCharacter(this.location.draggable);
    }
  }

  startDragCharacter(
    characterId,
    slotRef,
    clothSlotRef,
    clothId,
    wx,
    wy,
    pointer,
    fromHidingPlace = false
  ) {
    //
    slotRef.setStateDrag();

    // hide arrows
    this.gameHud.charactersList.setArrowsVisibility(false);

    // place dragged character
    this.location.placeDragCharacter(characterId, slotRef, clothSlotRef, clothId, wx, wy, pointer);

    // show hot spots
    this.location.showSlotMarkers(characterId);

    //
    if (fromHidingPlace) {
      this.toPlace++;
      this.gameHud.hideContinueButton();
    }

    //
    this.onDragCharacter.dispatch();
  }

  stopDragCharacter(characterRef) {
    // show arrows
    this.gameHud.charactersList.setArrowsVisibility(true);

    // remove from location
    this.location.removeDragCharacter();

    // hide hot spots
    this.location.hideSlotMarkers();

    // assign to slot on level if over it
    // update slot in hud
    const result = this.location.tryAddCharToSlot(characterRef);
    if (result.added) {
      // placed
      characterRef.slotRef.setStateHidden();

      // reduce placed characters only if slot was empty
      if (result.wasSlotEmpty) {
        this.toPlace--;
      }

      this.game.sounds.playSFX('place_object', { spriteID: 'sfx_gameplay', volume: 0.3 });

      // dispatch signal
      this.onHideCharacter.dispatch();

      // display 'continue' button
      if (this.toPlace === 0) {
        this.displayContinueButton();
      }

      // debug
      // const pos = result.slot.getCharacterPos();
      // this.makeScreenshot(pos.x, pos.y, result.slot.character);
      // this.handleShowExplainer(result.slot);
    } else {
      // not placed
      characterRef.slotRef.setStateInitial();
    }
  }

  displayContinueButton() {
    // this.gameHud.onConfirmHide.addOnce(this.handleButtonContinue, this);
    this.gameHud.showContinueButton();
  }

  handleButtonContinue() {
    // lock placed characters
    this.location.lockCharacters();

    // hide scroll arrows
    this.gameHud.hideScrollArrows();
    this.location.disableControls();

    // hide clothing buttons
    this.location.hideCharacterDressUpButtons();

    // add seeker
    this.seeker = new Seeker(
      this.game,
      this.seekerId,
      this.locationData.nav_points,
      this.levelData.start_point,
      100,
      this.levelData.sceneWidth - 100
    );
    this.location.placeSeeker(this.seeker);

    // add seeker to camera and position camera on seeker
    this.camera.setTarget(this.seeker);
    this.camera.setPosition(this.seeker.x);

    // start seeking AI
    this.AI = new SeekingAI(
      this.game,
      this.location,
      this.location.getSlotsWithChars(),
      this.seeker,
      this.levelData.quick_find
    );
    this.AI.onFindChar.add(this.handleFindChar, this);
    // this.AI.onShowExplainer.add(this.handleShowExplainer, this);
    // this.AI.getNextTarget();

    // show talking elinor
    this.gameHud.onCloseElinor.addOnce(this.handleCloseElinor2, this);
    this.gameHud.showOverlayElinorTalk(['cs_10b_elinor_001', 'ui_01_elinor_' + this.seekerId]);
  }

  handleCloseElinor2() {
    // show count overlay
    this.gameHud.onCountEnd.addOnce(this.handleCountEnd, this);
    this.gameHud.showOverlayCount(this.seekerId, false);
  }

  handleCountEnd() {
    this.transition.onFadeEnd.addOnce(this.handleTransitionEndAfterCount, this);
    this.transition.fadeIn();
  }

  handleTransitionEndAfterCount() {
    this.gameHud.removeOverlayCount();
    this.transition.onFadeEnd.addOnce(this.handleTransitionEndToStart, this);
    this.transition.fadeOut();
  }

  handleTransitionEndToStart() {
    this.AI.getNextTarget();
  }

  handleFindChar(characterId, slot) {
    // play vo "found you" with small delay for stars sfx
    const ind = Math.floor(3 * Math.random()); // todo: add voiceover 017
    const ids = ['011', '015', '016'];
    let voId = ids[ind];
    voId = slot.rating === 2 ? '012' : voId;
    const textId = 'vo_01_' + this.seekerId + '_' + voId;
    this.game.springRollCaptionsPlugin.playCaption(textId);
    this.game.sounds.playVO(textId, {
      spriteID: this.seekerId + '_vo',
      delay: 400,
    });
    this.seeker.talk(1000, 450);

    // register next seeker -> first found character
    if (this.found === 0) {
      this.game.controller.nextSeekerId = characterId;
    }

    //
    this.found++;

    // collect data
    const charData = slot.data.characters.find((e) => e.id === characterId);
    let explainerData = charData.explainer;
    if (slot.character.clothId !== -1) {
      explainerData = slot.data.clothes.find((d) => d.id === slot.character.clothId).explainer;
    }

    this.foundData[characterId] = {
      charId: characterId,
      slotId: slot.data.id,
      rating: slot.rating,
      clothId: slot.character.clothId,
      explainerData: explainerData,
    };

    // delayed actions on reveal character - see celebrate time in SeekingAI
    this.game.time.events.add(1500, this.revealCharacter, this, characterId, slot);
  }

  revealCharacter(characterId, slot) {
    // show in hud found character
    this.gameHud.charactersList.revealCharacter(characterId);

    // show stars popup
    this.ratings[characterId] = slot.rating;
    slot.showStarsPopup();
    this.game.time.events.add(2000, this.handleCloseStarsPopup, this);
  }

  handleCloseStarsPopup() {
    this.finishLevel();
  }

  //
  finishLevel() {
    if (this.found >= this.toFind) {
      // this.game.time.events.add(1000, this.showResult, this);
      this.transition.onFadeEnd.addOnce(this.handleTransitionEndToResult, this);
      this.transition.fadeIn();

      // tracking
      let season = this.game.controller.location;
      season = season.replace(/^\w/, (chr) => chr.toUpperCase());
      let action = 'EndLevel_' + season + '_Level_' + (this.levelData.id + 1);
      if (this.game.controller.replays > 0) {
        action += '_Replay_' + this.game.controller.replays;
      }
      let value = 0;
      const slots = this.location.getSlotsWithChars();
      for (let i = 0; i < slots.length; i++) {
        value += slots[i].rating + 1;
      }

      getGA().track({ action: action, value: value });
    }
  }

  handleTransitionEndToResult() {
    // first show well done screen
    this.gameHud.onCloseResult.addOnce(this.handleCloseWellDone, this);
    this.gameHud.showOverlayResult(this.seekerId, this.charsData);
    this.transition.fadeOut();
  }

  handleCloseWellDone() {
    this.gameHud.onCloseResult.addOnce(this.handleCloseResult, this);
    this.gameHud.showOverlayResultHide(this.charsData, this.foundData, this.screenShots);
  }

  handleCloseResult(replayLevel) {
    this.replayLevel = replayLevel;
    this.transition.onFadeEnd.addOnce(this.handleTransitionEndToNextLevel, this);
    this.transition.fadeIn();
  }

  handleTransitionEndToNextLevel() {
    if (this.replayLevel) {
      this.game.controller.replayLevel();
    } else {
      this.game.controller.endLevel();
    }
  }

  makeScreenshot(cx, cy, character) {
    console.log('makeScreenshot');
    cx += this.location.x; // + character.slotRef.parent.x;

    const scale = 1.5;
    const mask = this.game.make.image(0, 0, 'explain_mask');
    const w = mask.width;
    const h = mask.height;

    const left = w / scale / 2;
    const right = this.game.width - left;
    const top = h / scale / 2;
    const bottom = this.game.height - top;
    const ax = Phaser.Math.clamp(cx, left, right); // Math.max(left, Math.min(right, cx));
    const ay = Phaser.Math.clamp(cy, top, bottom); // Math.max(top, Math.min(bottom, cy));

    const img = this.game.make.image(w / 2, h / 2);

    this.seeker.visible = false;
    this.gameHud.visible = false;
    this.game.renderer.render(this.game.stage);
    img.setTexture(PIXI.Texture.fromCanvas(this.game.canvas));
    this.seeker.visible = true;
    this.gameHud.visible = true;

    img.anchor.set(ax / this.game.width, ay / this.game.height);
    img.scale.set(scale);
    const bmdScreenshot = this.game.make.bitmapData(w, h);
    bmdScreenshot.alphaMask(img, mask);

    //
    img.anchor.set(ax / this.game.width, ay / this.game.height);
    img.scale.set(1.5);
    const bmdScreenshot2 = this.game.make.bitmapData(w, h);
    bmdScreenshot2.draw(img);

    //
    this.screenShots[character.charData.id] = {
      bmd: bmdScreenshot,
      bmd2: bmdScreenshot2,
      dx: cx - ax,
      dy: cy - ay,
      cx: cx,
      cy: cy,
    };
  }

  //
  openDressUp(characterRef, characterId, clothId) {
    this.characterDressUpRef = characterRef;

    // lock scroll
    this.location.disableControls();
    this.gameHud.arrowsContainer.visible = false;

    // hide hud icons
    this.gameHud.charactersList.visible = false;

    // lock characters on stage
    this.location.lockCharacters();
    this.location.findSlotWithCharacter(characterId).unlockCharacterCheckBtn();

    // hide other dress up buttons
    this.location.hideCharacterDressUpButtons(characterId);

    // show clothes
    this.gameHud.showDressUp(characterRef, characterId, clothId);
  }

  hideDressUp() {
    // unlock scroll
    this.location.enableControls();
    this.gameHud.arrowsContainer.visible = true;

    // show hud icons
    this.gameHud.charactersList.visible = true;

    // unlock characters on stage
    this.location.unlockCharacters();

    //
    this.location.showCharacterDressUpButtons();

    // hide clothes
    this.gameHud.hideClothes();
  }

  startDragCloth(clothSlotRef, clothData, pointer) {
    clothSlotRef;
    clothData;
    pointer;

    // place dragged cloth
    this.location.placeDragCloth(clothSlotRef, clothData, pointer);
  }

  stopDragCloth(clothDragRef, forceAdd = false) {
    // remove from location
    this.location.removeDragCloth();

    // assign to character if closer to it
    const charRef = this.characterDressUpRef;
    const slotRef = clothDragRef.slotRef;
    const dx0 = clothDragRef.worldPosition.x - slotRef.worldPosition.x;
    const dy0 = clothDragRef.worldPosition.y - slotRef.worldPosition.y;
    const dx1 = clothDragRef.worldPosition.x - charRef.worldPosition.x;
    const dy1 = clothDragRef.worldPosition.y - charRef.worldPosition.y;
    const dist0 = dx0 * dx0 + dy0 * dy0; // distance to slot
    const dist1 = dx1 * dx1 + dy1 * dy1; // distance to character

    if (dist1 < dist0 || forceAdd) {
      // add to character
      charRef.wearCloth(clothDragRef.slotRef, clothDragRef.clothData);

      // add chars cloth to slot or reset
      if (charRef.clothId > -1) {
        slotRef.showCharacterCloth(charRef.charData.id);
      } else {
        slotRef.resetOutfit();
      }

      this.game.sounds.playSFX('clothes_on', { spriteID: 'sfx_gameplay', volume: 0.3 });
    } else {
      // return to list
      slotRef.returnOutfit();
    }
  }

  setArrowsVisibility() {
    if (!this.gameHud.arrowsLocked) {
      this.setCurrentNavPoint();
      this.gameHud.hideScrollArrows();
      const cx = this.camera.currentX;
      this.gameHud.showScrollArrows(
        cx >= this.navPoints[0] + 1,
        cx <= this.navPoints[this.navPoints.length - 1] - 1
      );
    }
  }

  //
  update() {
    const dt = Math.min(0.1, this.game.time.elapsedMS / 1000);

    // keyboard controls
    if (this.location.controlsEnabled && this.game.controller.gameMode === MODE_HIDE) {
      if (this.game.input.keyboard.isDown(Phaser.Keyboard.LEFT)) {
        this.camera.destX -= 10;
      }
      if (this.game.input.keyboard.isDown(Phaser.Keyboard.RIGHT)) {
        this.camera.destX += 10;
      }
    }

    //
    if (this.seeker) {
      this.seeker.step(dt);
    }
    this.location.step(dt);
    this.camera.step(dt);

    // set visibility of arrows when drag
    if (this.location.isDraggingScene || this.location.isDraggingCharacter) {
      this.setArrowsVisibility();
    }

    // update onboarding controller
    if (this.game.onboarding) {
      this.game.onboarding.step(dt);
    }
  }

  shutdown() {
    //
    if (this.game.onboarding) {
      this.game.onboarding.onEnd.remove(this.handleOnboardingEnd, this);
      this.game.onboarding.destroy();
      this.game.onboarding = null;
    }

    this.screenShots = null;

    if (this.seeker) {
      this.seeker.destroy();
      this.seeker = null;
    }

    // clear up
    this.container.destroy(true);
    this.container = null;

    super.shutdown();
  }
}
